var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-input-number"},[_c('button',{staticClass:"btn-minus",on:{"click":_vm.minus}}),_c('span',[_vm._v(_vm._s(_vm.getNum))]),_c('button',{staticClass:"btn-add",on:{"click":_vm.add}})])}
var staticRenderFns = []

export { render, staticRenderFns }